import api from './';

export default {
  getProjectTasks(arg) {
    return api.post('ProjectTasks/GetList', { projectGuid: arg }).then(response => response.data);
  },

  getAllProjectTasks() {
    return api.post('ProjectTasks/GetAll', {}).then(response => response.data);
  },

  getProjectTask(arg) {
    return api.post('ProjectTasks/Get', { taskGuid: arg }).then(response => response.data);
  },

  saveProjectTask(arg) {
    return api.post('ProjectTasks/Save', { projectTask: arg }).then(response => response.data);
  },

  searchProjectTask(arg) {
    return api.post('ProjectTasks/Search', { search: arg }).then(response => response.data);
  },

  deleteProjectTask(arg) {
    return api.post('ProjectTasks/Delete', { taskGuid: arg }).then(response => response.data);
  },

  editProjectTask(arg) {
    return api.post('ProjectTasks/Edit', { projectTask: arg }).then(response => response.data);
  },
};
